import actions from './actions';

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const initialStateUpdate = {
  data: [],
  loading: false,
  error: null,
};

const {
  SINGLE_CHAT_BEGIN,
  SINGLE_CHAT_SUCCESS,
  SINGLE_CHAT_ERR,

  UPDATE_PRIVET_CHAT_BEGIN,
  UPDATE_PRIVET_CHAT_SUCCESS,
  UPDATE_PRIVET_CHAT_ERR,
} = actions;

const chatReducer = (state = initialStateUpdate, action) => {
  const { type, data, err } = action;
  switch (type) {
    case UPDATE_PRIVET_CHAT_BEGIN:
      return {
        ...initialStateUpdate,
        loading: true,
      };
    case UPDATE_PRIVET_CHAT_SUCCESS:
      return {
        ...initialStateUpdate,
        data,
        loading: false,
      };
    case UPDATE_PRIVET_CHAT_ERR:
      return {
        ...initialStateUpdate,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const SingleChatReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SINGLE_CHAT_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case SINGLE_CHAT_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };
    case SINGLE_CHAT_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export { SingleChatReducer, chatReducer };
